// Copyright ©️ 2026 eVolve MEP, LLC

/**
 * Programmatically triggers a file download in the browser by creating a temporary anchor element.
 * After the download is initiated, the anchor element is removed from the DOM.
 *
 * @param fileName The name to give the downloaded file, including extension
 * @param url The URL of the file to download. Can be a standard URL or an object URL created via `URL.createObjectURL`. The caller must revoke any object URLs created for this function.
 */
export const downloadFileViaLinkElement = (fileName: string, url: string) => {
  const link = document.createElement('a');
  link.download = fileName;
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

/**
 * A wrapper around {@link downloadFileViaLinkElement} to download a blob.
 *
 * @param fileName The name to give the downloaded file, including extension
 * @param blob The blob to download
 */
export const downloadBlobViaLinkElement = (fileName: string, blob: Blob) => {
  const url = URL.createObjectURL(blob);
  downloadFileViaLinkElement(fileName, url);
  URL.revokeObjectURL(url);
};
